import type { EqmsUpdateRequestStatus } from '../../../types/eqms.types';

export const UPDATE_REQUEST_STATUS_STYLES: Record<EqmsUpdateRequestStatus, string> = {
  open: 'border-amber-200 bg-amber-50 text-amber-800',
  addressing: 'border-teal-200 bg-teal-50 text-teal-800',
  parked: 'border-violet-200 bg-violet-50 text-violet-800',
  declined: 'border-slate-200 bg-slate-100 text-slate-600',
  done: 'border-emerald-200 bg-emerald-50 text-emerald-800',
};
